import React from 'react';
import {Accordion} from 'react-bootstrap';
import {theme} from '../../../../styles/darkTheme';
import {Text} from './styles';

interface Props {
  eventKey: string;
  children: React.ReactNode;
}

const Body: React.FC<Props> = ({eventKey, children}) => {
  return (
    <Accordion.Collapse eventKey={eventKey}>
      <Text theme={theme}>{children}</Text>
    </Accordion.Collapse>
  );
};

export default Body;
